import type {RefObject} from 'react';

/**
 * The `ChevronRightIconProps` interface defines the properties for the ChevronRightIcon component.
 */
interface ChevronRightIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "chevron_right" — outlined, weight 300.
 * Right-pointing chevron for navigation or disclosure.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const ChevronRightIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'ChevronRightIcon',
    width
}: ChevronRightIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
    </svg>
);

ChevronRightIcon.displayName = 'ChevronRightIcon';